import { Component, EventEmitter, HostListener, Inject, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { AppComponent } from '../../app/app.component';
import { ViewerDataService } from '../viewer-data.service';
import { ViewerService } from '../viewer.service';

@Component({
  selector: 'app-viewer-header',
  templateUrl: './viewer-header.component.html'
})
export class ViewerHeaderComponent implements OnInit {


  requestName: string;
  @Output('startNextAction') startNextAction = new EventEmitter();

  @HostListener('window:scroll') onScroll() {
    let currentScrollPosition: number = window.scrollY;

    let subnavbar = <HTMLElement><any>document.getElementById("performaction-sub-navbar");
    if (currentScrollPosition > 200 && currentScrollPosition > this.oldScrollPosition) {
      subnavbar.classList.add("fadeOut");
      subnavbar.classList.remove("fadeIn");
    } else {
      subnavbar.classList.add("fadeIn");
      subnavbar.classList.remove("fadeOut");
    }
    this.oldScrollPosition = currentScrollPosition;
  }
  oldScrollPosition: number = 0;
  currentLanguage!: any;
  /**
   * Whether the subheader should be shown, this holds the Next button, and action menu
   * Must be hdden for completed/Download request
   */
  displaySubHeaderBar = true;

  constructor(@Inject(DOCUMENT) private docElements: Document, private translateService: TranslateService, public whiteLabelProvider: AppComponent,
    private viewerDataService: ViewerDataService, private viewerService: ViewerService) {
    this.requestName = this.viewerDataService.get_RequestName;
    this.currentLanguage = this.translateService.store.currentLang;
    if (this.currentLanguage == undefined) {
      this.currentLanguage = this.translateService.store.defaultLang;
    }
    this.translateService.onLangChange.subscribe((language: any) => {
      if (language != undefined)
        this.currentLanguage = language.lang
    }
    );
    this.viewerService.requestCompleted$.subscribe((isCompleted) => {
      if (isCompleted) {
        this.displaySubHeaderBar = false;
      }
    });
    this.viewerDataService.getCompleted$().subscribe(() => {
      this.displaySubHeaderBar = false;
    });
    this.viewerService.showDownloadPage$.subscribe((isDownloadPage) => {
      if (isDownloadPage) {
        this.displaySubHeaderBar = false;
      }
    });

  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  public startActions(): void {
    this.startNextAction.emit()
  }

  setLanguage(language: string) {
    localStorage.setItem("language", language);
    this.translateService.use(language);
    this.docElements.documentElement.lang = language;
  }

  getLanguages() {
    return this.translateService.getLangs();
  }
}
